import { RecommendPanel } from '@doda/common/src/interfaces/api/recommendPanel';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { jobListSelector } from 'redux/features/jobList';
import { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import {
  getDefaultRecommendPanel,
  getRecommendPanel,
} from 'pages/DodaFront/View/JobSearchList/logics/getRecommendPanel';

const getJobListTop5Item = (jobListRes: JobSearchResultResponse[]) => {
  const jobListTop5Item: string[] = [];

  if (jobListRes.length >= 5) {
    for (let i = 0; i < 5; i += 1) {
      const { jid } = jobListRes[i];
      if (jid) {
        jobListTop5Item.push(jid);
      }
    }
  } else {
    for (let i = 0; i < jobListRes.length; i += 1) {
      const { jid } = jobListRes[i];
      if (jid) {
        jobListTop5Item.push(jid);
      }
    }
  }

  return jobListTop5Item;
};

interface RecommendResult {
  recommendForSlider: RecommendPanel | null;
  recommendForList: RecommendPanel | null;
}

const initialState: RecommendResult = {
  recommendForSlider: null,
  recommendForList: null,
};

/**
 * レコメンドデータを取得
 * @returns レコメンドデータ
 */
export const useRecommend = () => {
  const jobListRes = useSelector(jobListSelector);
  const [recommend, setRecommend] = useState<RecommendResult>(initialState);

  useEffect(() => {
    const jobListTop5Item = getJobListTop5Item(jobListRes);
    (async () => {
      try {
        const res = await getRecommendPanel(jobListTop5Item);
        if (!res) throw new Error('No Response');
        setRecommend((pre) => ({ ...pre, recommendForList: res }));
      } catch {
        try {
          const res = await getDefaultRecommendPanel();
          if (res) setRecommend((pre) => ({ ...pre, recommendForSlider: res }));
        } catch {
          // 両方のリクエストデータが取得できなかった場合は非表示
        }
      }
    })();
  }, [jobListRes]);

  return recommend;
};
